module.exports = __webpack_public_path__ + "image_placeholder.ebe9884b2152a08a525f.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/dj/Desktop/git.nosync/adserver/AdServerExchange-ANGLR/src/assets/img/image_placeholder.jpg
// module id = ../../../../../src/assets/img/image_placeholder.jpg
// module chunks = styles